import { EnumType, IEnumType } from "./Base/EnumType";

export class MaterialType extends EnumType {
    // #region Constants

    public static readonly Placeholder = "PLACEHOLDER";

    // #endregion Constants

    // #region Properties
    // #endregion Properties

    // #region Methods

    public fromDto(dto: IMaterialType) {
        super.fromDto(dto);
    }

    // #endregion Methods
}

export interface IMaterialType extends IEnumType {}
